import * as React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
export const defaultTheme = {
    primaryColour: '#333333',
    activeColour: '#0277bd',
    successColour: '#388e3c',
    dangerColour: '#c62828',
    warningColour: '#FFB74D',
    borderColour: '#b3b3b3',
    fontFamily: 'inherit',
    fontSize: '14px',
};
export const ThemeProvider = ({ children }) => (React.createElement(EmotionThemeProvider, { theme: Object.assign({}, defaultTheme) }, children));
//# sourceMappingURL=theme.provider.js.map